const state = {
  userInfo: {}, //用户信息
  allSelect: {}, //全局字典项
  sence: '', //H5打开的场景值  0 微信自定义应用 1微信小程序 2 非微信环境浏览器
  toast: {
    show: false, //是否开启toast
    title: '', //toast的话术
    icon: 'success' //success: 成功 none: 无 (与小程序一致)
  },
  loadingToast: {
    show: false, //是否开启loadingToast
    title: '数据加载中' //loadingToast的话术
  }
}
export default state
